site.hero = {
	owl: $('#owl-hero'),

	init: function() {
		if ($('.banner__container', site.hero.owl).length < 2) return;

		site.hero.owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
		site.hero.owl.owlCarousel({
			loop:true,
			nav:true,
			navText:["",""],
			dots: false,
			stopOnHover: true,
			autoplay: false,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			items: 1
		});

		//site.hero.bindDown();
	},

	bindDown: function() {
		site.hero.owl.find('.scroll').click(function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop:site.hero.owl.offset().top + site.hero.owl.height() - $('#header').height()}, 'slow');
		});
	}
};

site.inits.push('site.hero.init()');
